import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import validator from "validator";
import { IconButton2 } from "../../button/icon-action-buttons";
import { InternalLink } from "../../custom-svgs/action-svg";
import "../display.css";

export default function InputDisplay(props) {
  const [showIcon, setShowIcon] = useState(false);
  const history = useHistory();

  if (props.field && props.data && typeof props.data === "string" && typeof props.field === "object" && props.field.validation === "URL_VALIDATION" && validator.isURL(props.data)) {
    const validUrl = !props.data.includes("http") ? `https://${props.data}` : props.data;
    return (
      <OverlayTrigger placement="bottom" overlay={<Tooltip>{props.data}</Tooltip>} trigger={["hover", "focus"]}>
        <div className={`data-container2`}>
          <span className="data-container-2-text">{props.data}</span>
          <a className="data-container-2-icon" rel="noopener noreferrer" href={validUrl} target={"_blank"} onClick={(e) => e.stopPropagation()}>
            <i style={{ cursor: "pointer", color: "#00acff", fontSize: "12px" }} className="bi bi-box-arrow-up-right" />
          </a>
        </div>
      </OverlayTrigger>
    );
  } else if (props.field && props.data && props.field.internalLink && typeof props.data === "string" && typeof props.field === "object") {
    return (
      // <OverlayTrigger placement="bottom" overlay={<Tooltip>{props.data}</Tooltip>} trigger={["hover", "focus"]}>
      //   <div className={`data-container2`}>
      //     <span className="data-container-2-text">{props.data}</span>
      //     <span className="data-container-2-icon" onClick={(e) => { e.stopPropagation(); history.push(props.field.internalLink) }}>
      //       {/* <i style={{ cursor: "pointer", color: "#00acff", fontSize: "12px" }} className="bi bi-box-arrow-up-right" /> */}
      //       {InternalLink}
      //     </span>
      //   </div>
      // </OverlayTrigger>
      <>
        <div className="d-flex justify-content-between w-100" onMouseEnter={() => setShowIcon(true)} onMouseLeave={() => setShowIcon(false)}>
          <OverlayTrigger placement="bottom" overlay={<Tooltip>{props.data}</Tooltip>} trigger={["hover", "focus"]}>
            <div className={`data-container2`}>
              <span className="data-container-2-text">{props.data}</span>
            </div>
          </OverlayTrigger>
          <div onClick={(e) => e.stopPropagation()}>
            {showIcon ? (
              <IconButton2
                style={{ height: "25px", width: "25px" }}
                className="btn btn-icon btn-light"
                onClick={(e) => {
                  e.stopPropagation();
                  history.push(props.field.internalLink);
                }}
                tooltip={`${props.field.internalTooltip}`}
              >
                {InternalLink}
              </IconButton2>
            ) : (
              <div style={{ justifySelf: "flex-end", width: 25, height: 25 }}></div>
            )}
          </div>
        </div>
      </>
    );
  }

  return (
    <OverlayTrigger placement="bottom" overlay={<Tooltip>{props.data}</Tooltip>} trigger={["hover", "focus"]}>
      <span
        className={`data-container`}
        style={{
          maxWidth: "250px",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {props.data}
      </span>
    </OverlayTrigger>
  );
}
